import { render, staticRenderFns } from "./ExistingCommentIcon.vue?vue&type=template&id=49798331"
import script from "./ExistingCommentIcon.vue?vue&type=script&lang=js"
export * from "./ExistingCommentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports